export default __webpack_public_path__ + "static/media/closeCompany.84660d69.svg";